import {$swoole} from '@api/axios.setup'

// getTCConsultant
// - 2024.08.13
// - Gey consultant of taoche
export async function getTCConsultant (payload) {
  try {
    const url = '/v1/tcAdviser'
    const response = await $swoole.get(url, {
      params: payload && payload.params || null,
    })

    return response.data.data
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}